import { render, staticRenderFns } from "./status_text_sale.vue?vue&type=template&id=3e3bae92"
import script from "./status_text_sale.vue?vue&type=script&lang=js"
export * from "./status_text_sale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports